import type { RouteRecordRaw } from 'vue-router'

const customerRoutes: RouteRecordRaw[] = [
  {
    path: '/pembeli',
    component: () => import('@/views/app/the-layout.vue'),
    children: [
      {
        path: '',
        name: 'customer list',
        component: () => import('@/views/app/customer/page-list.vue'),
        meta: { title: 'List Pembeli' },
      },
    ],
  },
]

export default customerRoutes
